import React from 'react';

export const Loader = () => (
  <div className="App">
    <div>loading...</div>
  </div>
);
